/* ==========================================================================
   Cookie consent banner — calls window.Shopify.customerPrivacy when the
   user makes a choice. Stores the consent timestamp locally so we can
   re-prompt after 12 months (regulatory norm). Banner reveals on first
   visit and any time the stored consent expires.
   ========================================================================== */

(function () {
    const STORAGE_KEY = 'vidalite_cookie_consent_v1';
    const CONSENT_TTL_DAYS = 365;

    function readStored() {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return null;
            const parsed = JSON.parse(raw);
            const ageDays = (Date.now() - parsed.ts) / (1000 * 60 * 60 * 24);
            if (ageDays > CONSENT_TTL_DAYS) return null;
            return parsed;
        } catch (_) { return null; }
    }

    function writeStored(state) {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify({
                ts: Date.now(),
                analytics: !!state.analytics,
                marketing: !!state.marketing,
            }));
        } catch (_) { /* private mode etc — ignore */ }
    }

    // Apply consent to Shopify's privacy API so analytics / pixel scripts gate on it.
    function applyConsent(state) {
        if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
            try {
                window.Shopify.customerPrivacy.setTrackingConsent({
                    analytics:   !!state.analytics,
                    marketing:   !!state.marketing,
                    preferences: !!state.analytics, // bundled
                    sale_of_data: !!state.marketing,
                }, () => {});
            } catch (_) { /* ignore — banner still hides */ }
        }
        // Broadcast for any custom scripts that want to listen.
        document.dispatchEvent(new CustomEvent('vidalite:cookie-consent', { detail: state }));
    }

    document.addEventListener('DOMContentLoaded', () => {
        const banner = document.getElementById('cookie-banner');
        if (!banner) return;

        const existing = readStored();
        if (existing) {
            applyConsent(existing);
            return; // already consented, no banner
        }

        // Reveal banner
        banner.hidden = false;
        // Allow CSS transition to play
        requestAnimationFrame(() => {
            banner.setAttribute('data-open', 'true');
            // Move focus to the first action button so keyboard + screen-reader
            // users encounter the choice immediately. Not a full focus trap —
            // banner shouldn't block the rest of the page if users want to
            // ignore it.
            const firstAction = banner.querySelector('.cookie-banner__btn');
            if (firstAction) try { firstAction.focus(); } catch (_) {}
        });

        const prefsForm = banner.querySelector('[data-cookie-prefs]');
        const acceptBtn = banner.querySelector('[data-cookie-accept]');
        const rejectBtn = banner.querySelector('[data-cookie-reject]');
        const customizeBtn = banner.querySelector('[data-cookie-customize]');
        const saveBtn = banner.querySelector('[data-cookie-save]');
        const catInputs = banner.querySelectorAll('[data-cookie-cat]');

        function commit(state) {
            writeStored(state);
            applyConsent(state);
            banner.removeAttribute('data-open');
            // Wait for slide-out, then remove from DOM
            setTimeout(() => { banner.hidden = true; }, 400);
        }

        acceptBtn?.addEventListener('click', () => commit({ analytics: true, marketing: true }));
        rejectBtn?.addEventListener('click', () => commit({ analytics: false, marketing: false }));

        customizeBtn?.addEventListener('click', () => {
            if (prefsForm) {
                const open = prefsForm.hasAttribute('hidden');
                if (open) prefsForm.removeAttribute('hidden');
                else      prefsForm.setAttribute('hidden', '');
            }
        });

        saveBtn?.addEventListener('click', () => {
            const state = { analytics: false, marketing: false };
            catInputs.forEach(input => {
                if (input.checked) state[input.dataset.cookieCat] = true;
            });
            commit(state);
        });
    });
})();
